import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=68e1e996&scoped=true"
import script from "./ItemEdit.vue?vue&type=script&lang=js"
export * from "./ItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1e996",
  null
  
)

export default component.exports